export default {"src":"/_next/static/media/eye-open.085f83dd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};